import { render, staticRenderFns } from "./ladder-coupon-block.vue?vue&type=template&id=012bb85a&scoped=true&lang=pug&"
import script from "./ladder-coupon-block.vue?vue&type=script&lang=js&"
export * from "./ladder-coupon-block.vue?vue&type=script&lang=js&"
import style0 from "./ladder-coupon-block.vue?vue&type=style&index=0&id=012bb85a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012bb85a",
  null
  
)

export default component.exports